var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5000563,1.4997 L19.5000813,7.4997 L19.5000813,22.4997 L4.50001875,22.4997 L4.50001875,18.7497 L6.00001875,18.7497 L6.00001875,20.9997 L18.000075,20.9997 L18.000075,8.9997 L12.00005,8.9997 L12.00005,2.9997 L6.00001875,2.9997 L6.00001875,11.2497 L4.50001875,11.2497 L4.50001875,1.4997 L13.5000563,1.4997 Z M11.2499719,11.25 L14.9999875,15 L13.9394831,16.0605 L11.2499719,18.75 L9.12896304,18.75 L12.1289755,15.75 L1.49993125,15.75 L1.49993125,14.25 L12.1289755,14.25 L9.12896304,11.25 L11.2499719,11.25 Z M13.5000563,3.62145 L13.5000563,7.4997 L17.3790724,7.4997 L13.5000563,3.62145 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImport);
export default __webpack_public_path__ + "static/media/documentImport.2686b841688a77a2575f621e3c409abd.svg";
export { ForwardRef as ReactComponent };